(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_countdown"] && !Shopify.designMode) return;
  try {
    // [FROST BUDDY] Countdown "Notify" button → open the co-located signup modal.
  // Delegated + guarded so it binds once no matter how many countdown blocks render.
  if (!window.__fbCountdownModalBound) {
    window.__fbCountdownModalBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-countdown-notify]');
      if (trigger) {
        const root = trigger.closest('.countdown-block') || document;
        const modal = root.querySelector('[data-countdown-modal]');
        if (modal && typeof modal.showModal === 'function') {
          event.preventDefault();
          modal.showModal();
        }
        return;
      }

      if (event.target.closest('[data-countdown-modal-close]')) {
        const dialog = event.target.closest('dialog');
        if (dialog) dialog.close();
        return;
      }

      // Click on the backdrop (the dialog element itself) closes it.
      if (event.target instanceof HTMLElement && event.target.hasAttribute('data-countdown-modal')) {
        event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_fb-drop-countdown"] && !Shopify.designMode) return;
  try {
    class FbDropCountdown extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
      this.target = null;
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    init() {
      let result;
      if (this.dataset.manualMode === 'true') {
        const target = this.buildManualTarget();
        result = target === null ? null : { target, element: null };
      } else {
        result = this.findNextDropTarget();
      }
      if (result === null) return;

      this.target = result.target;
      this.applyDynamicHeading(result.element);

      const wrapper = this.closest('.fb-drop-countdown');
      if (wrapper) wrapper.hidden = false;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    buildManualTarget() {
      const y = Number(this.dataset.year);
      const m = Number(this.dataset.month);
      const d = Number(this.dataset.day);
      const h = Number(this.dataset.hour);
      const min = Number(this.dataset.minute);
      if (!y || !m || !d) return null;
      const target = this.easternWallClockToUtc(y, m, d, h, min);
      return Number.isNaN(target) ? null : target;
    }

    stop() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    findNextDropTarget() {
      const now = Date.now();
      let best = null;
      const nodes = document.querySelectorAll('[data-fb-drop-date]');

      for (const el of nodes) {
        const raw = el.dataset.fbDropDate;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) continue;
        const [y, m, d] = raw.split('-').map(Number);
        // Optional per-drop time (Eastern wall-clock) from data-fb-drop-hour/minute.
        // Absent → 9:00 AM ET, the historical default for the drops calendar.
        const rawHour = el.dataset.fbDropHour;
        const rawMinute = el.dataset.fbDropMinute;
        const h = rawHour == null || rawHour === '' ? 9 : Number(rawHour);
        const min = rawMinute == null || rawMinute === '' ? 0 : Number(rawMinute);
        const target = this.easternWallClockToUtc(y, m, d, h, min);
        if (Number.isNaN(target) || target <= now) continue;
        if (best === null || target < best.target) best = { target, element: el };
      }

      return best;
    }

    applyDynamicHeading(element) {
      if (!element) return;
      const heading = this.querySelector('[data-text="default"]');
      if (!heading) return;

      const collection = element.dataset.fbDropCollectionName || '';
      const design = element.dataset.fbDropDesignName || '';
      // Shopify's richtext setting encodes "{" and "}" as the HTML entities
      // &lcub;/&rcub;, so the placeholders arrive here as "&lcub;design&rcub;"
      // rather than "{design}". Normalize them back before substituting, or the
      // replace never matches and the literal placeholder renders on screen.
      const normalize = (tpl) => tpl.replaceAll('&lcub;', '{').replaceAll('&rcub;', '}');
      const collectionTpl = normalize(this.dataset.textCollection || '');
      const designTpl = normalize(this.dataset.textDesign || '');

      let html = null;
      if (collection && collectionTpl) {
        html = collectionTpl.replaceAll('{collection}', this.escapeHtml(collection));
      } else if (design && designTpl) {
        html = designTpl.replaceAll('{design}', this.escapeHtml(design));
      }
      if (html !== null) heading.innerHTML = html;
    }

    escapeHtml(s) {
      const div = document.createElement('div');
      div.textContent = s;
      return div.innerHTML;
    }

    easternWallClockToUtc(year, month, day, hour, minute) {
      const naive = Date.UTC(year, month - 1, day, hour, minute);
      const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
      const parts = Object.fromEntries(
        fmt.formatToParts(new Date(naive)).map(p => [p.type, p.value])
      );
      const shown = Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        Number(parts.hour),
        Number(parts.minute)
      );
      return naive + (naive - shown);
    }

    tick() {
      const distance = this.target - Date.now();

      if (distance <= 0) {
        this.set('days', 0);
        this.set('hours', 0);
        this.set('minutes', 0);
        this.set('seconds', 0);
        this.handleComplete();
        this.stop();
        return;
      }

      const day = 86_400_000;
      const hour = 3_600_000;
      const minute = 60_000;
      const second = 1_000;

      this.set('days', Math.floor(distance / day));
      this.set('hours', Math.floor((distance % day) / hour));
      this.set('minutes', Math.floor((distance % hour) / minute));
      this.set('seconds', Math.floor((distance % minute) / second));
    }

    set(name, value) {
      const el = this.querySelector('[data-cell="' + name + '"]');
      if (el) el.textContent = String(value).padStart(2, '0');
    }

    handleComplete() {
      if (this.dataset.hideOnComplete === 'true') {
        const timer = this.querySelector('.fb-drop-countdown__timer');
        if (timer) timer.hidden = true;
      }
      const defaultText = this.querySelector('[data-text="default"]');
      const completedText = this.querySelector('[data-text="completed"]');
      if (defaultText && completedText) {
        defaultText.hidden = true;
        completedText.hidden = false;
      }
    }
  }

  if (!customElements.get('fb-drop-countdown')) {
    customElements.define('fb-drop-countdown', FbDropCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_fb-vip-unlock"] && !Shopify.designMode) return;
  try {
    (function () {
    var FLAG = 'fb_vip_autotrigger';

    document.addEventListener('click', function (event) {
      var link = event.target.closest('.fb-vip-unlock__cta--login');
      if (!link) return;
      try { sessionStorage.setItem(FLAG, '1'); } catch (e) {}
    });

    function fireTrigger() {
      var trigger = document.querySelector('.fb-vip-unlock .locksmith-manual-trigger');
      if (trigger && typeof Locksmith !== 'undefined' && Locksmith.postResource) {
        trigger.click();
      }
    }

    try {
      if (sessionStorage.getItem(FLAG) !== '1') return;
      sessionStorage.removeItem(FLAG);
    } catch (e) { return; }

    if (document.readyState === 'complete') {
      fireTrigger();
    } else {
      window.addEventListener('load', fireTrigger);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fb-bundle-toggle"] && !Shopify.designMode) return;
  try {
    class FBBundleToggle extends HTMLElement {
    connectedCallback() {
      // [FROST BUDDY] Only offer bundling when the page renders a sibling picker (a design family to
      // bundle). League/team products (data-league) are the exception — they bundle across a team
      // collection and never render a sibling picker. Fail-safe: default to showing if anything's off.
      if (this.dataset.league !== 'true' && !document.querySelector('sibling-picker')) {
        this.style.display = 'none';
        return;
      }
      this.klass = this.dataset.bundleClass || 'fb-bundle-active';
      this.sectionId = this.dataset.bundleSection;
      this.inputs = Array.from(this.querySelectorAll('input[type="radio"]'));
      this._onChange = this._onChange.bind(this);
      this._reset = this._reset.bind(this);
      this.inputs.forEach((input) => input.addEventListener('change', this._onChange));
      window.addEventListener('pageshow', this._reset);
      // [FROST BUDDY] Re-read the real discount after a sibling/size AJAX swap. The morph resets the
      // pill to the server fallback ("Save 15%") and does NOT re-fire connectedCallback, so listen for
      // the post-swap product-select event and re-sync (rAF so the new bundle section has settled).
      this._onProductSelect = () => requestAnimationFrame(() => {
        this._syncSavings();
        // [FROST BUDDY] The morph re-rendered the bundle grid with fresh lazy images. If the shopper
        // is already in bundle mode, re-warm so pill switches stay flicker-free after navigating.
        if (document.documentElement.classList.contains(this.klass)) {
          this._warmed = false;
          this._warmBundleImages();
        }
      });
      document.addEventListener('shopify:product:select', this._onProductSelect);
      this._syncSavings();
    }

    // Pull the real discount off the embedded fb-bundle-page section so the "Save X%" pill always
    // matches the actual bundle savings, instead of the static savings_text fallback. Shows the max
    // discount as "Save up to X%" for tiered bundles, or plain "Save X%" for a single discount.
    _syncSavings() {
      if (!this.sectionId) return;
      // Same stable-suffix lookup the scroll logic uses (see _onChange).
      const section = document.querySelector('[id$="__' + this.sectionId + '"]');
      const source = section && section.querySelector('[data-discount-max]');
      if (!source) return;
      const base = parseInt(source.dataset.discountPercent, 10);
      const max = parseInt(source.dataset.discountMax, 10);
      if (!Number.isFinite(max) || max <= 0) return;

      // "Save up to X%" for tiered bundles, or plain "Save X%" for a single discount.
      const saveText = max > base ? 'Save up to ' + max + '%' : 'Save ' + max + '%';

      // Pill layout.
      const pill = this.querySelector('.fb-bundle-toggle__save');
      if (pill) pill.textContent = saveText;

      // Cards layout — the "Add a 2nd" subtitle shows the same live savings text.
      const cardSave = this.querySelector('[data-fb-bt-save]');
      if (cardSave) cardSave.textContent = saveText;
    }

    disconnectedCallback() {
      this.inputs.forEach((input) => input.removeEventListener('change', this._onChange));
      window.removeEventListener('pageshow', this._reset);
      document.removeEventListener('shopify:product:select', this._onProductSelect);
      document.documentElement.classList.remove(this.klass);
    }

    _onChange(event) {
      const isBundle = event.target.value === 'bundle' && event.target.checked;
      document.documentElement.classList.toggle(this.klass, isBundle);
      if (isBundle && this.sectionId) {
        // [FROST BUDDY] Warm the top rows of each bundle size tab now that the shopper has opted into
        // bundling. Hidden tabs never trigger their lazy images, so the first pill switch pops in a
        // wave of images (the "flicker"). Eager-loading the first ~12 per tab on idle means the rows
        // seen immediately are cached by the time a pill is tapped — while shoppers who never open
        // the bundle still pay nothing.
        this._warmBundleImages();
        // Wait for the layout to settle (hiding the buy box shifts the bundle up) before scrolling,
        // so the scroll lands on the bundle's final position. scroll-margin-top handles the header offset.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          // A JSON-template section renders as #shopify-section-template--<themeId>__<key>,
          // so match by the stable id suffix rather than a fixed id.
          const section = document.querySelector('[id$="__' + this.sectionId + '"]');
          if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }));
      }
    }

    _warmBundleImages() {
      if (this._warmed) return;
      this._warmed = true;
      const section = document.querySelector('[id$="__' + this.sectionId + '"]');
      if (!section) return;
      const warm = () => {
        // Warm only the first ~12 cards per size tab — the rows seen immediately on switch — rather
        // than every image, to keep mobile data down. Deeper rows still lazy-load on scroll as usual.
        const perTab = {};
        section.querySelectorAll('img.fb-bundle-card__image[loading="lazy"]').forEach((img) => {
          const card = img.closest('.fb-bundle-card');
          const tab = card ? card.dataset.blockId : '_';
          (perTab[tab] = perTab[tab] || []).push(img);
        });
        Object.keys(perTab).forEach((tab) => {
          perTab[tab].slice(0, 12).forEach((img) => { img.loading = 'eager'; });
        });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 1200 });
      else requestAnimationFrame(warm);
    }

    _reset() {
      document.documentElement.classList.remove(this.klass);
      const single = this.querySelector('input[value="single"]');
      if (single) single.checked = true;
    }
  }

  if (!customElements.get('fb-bundle-toggle')) {
    customElements.define('fb-bundle-toggle', FBBundleToggle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fb-image-swap"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fb-image-swap')) {
    class FbImageSwap extends HTMLElement {
      connectedCallback() {
        const find = this.dataset.find;
        const replaceUrl = this.dataset.replaceUrl;
        if (!find || !replaceUrl) return;

        const url = new URL(replaceUrl, window.location.origin);
        const newName = url.pathname.split('/').pop();
        const newVersion = url.searchParams.get('v');
        const escaped = find.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        // Match "/files/<find>" plus its own ?v= cache-buster; any width/crop params that
        // follow are kept. Swapped URLs no longer contain <find>, so re-runs are no-ops.
        this.pattern = new RegExp(`/files/${escaped}(\\?v=\\d+)?`, 'g');
        this.replacer = (_match, hadVersion) =>
          `/files/${newName}${hadVersion && newVersion ? `?v=${newVersion}` : ''}`;
        this.alt = this.dataset.replaceAlt;
        this.root = this.closest('.shopify-section') || document.body;

        this.swap();
        this.observer = new MutationObserver(() => this.swap());
        this.observer.observe(this.root, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['src', 'srcset'],
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      swap() {
        for (const el of this.root.querySelectorAll('img, source')) {
          let changed = false;
          for (const attr of ['src', 'srcset']) {
            const value = el.getAttribute(attr);
            if (!value || !value.includes(this.dataset.find)) continue;
            this.pattern.lastIndex = 0;
            el.setAttribute(attr, value.replace(this.pattern, this.replacer));
            changed = true;
          }
          if (changed && this.alt && el instanceof HTMLImageElement) el.alt = this.alt;
        }
      }
    }

    customElements.define('fb-image-swap', FbImageSwap);
  }
  } catch(e) { console.error(e); }
})();

})();
